import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalHistory extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			history:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	

	handleShow(id){
		fetch(Config.default.apiGateway.URL+'patients/reserves_history?patient_id='+id,{
			method: 'GET',
			headers: new Headers({
				'Authorization'		: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'			: 'application/json',
				'Content-Type'		: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg) => {
					swal('error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show: true,
					history: response
				});		
			}
		})

				
	}

	handleClose(){
		this.setState({
			show: false,
			history:[]
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="lg" className="modal-history" show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Historial</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<Table>
								<thead>
									<tr>
										<th>No. Petición</th>
										<th>Fecha/Hr. Petición</th>
										<th>No. Muestra</th>
										<th>Fecha/Hr. Muestra</th>
										<th>Gpo/RH Muestra</th>
										<th>No. Unidad</th>
										<th>Componente</th>
										<th>Gpo/RH Unidad</th>
										<th>Compatibilidad</th>
										<th>Enviada</th>
									</tr>
								</thead>
								<tbody>
									{this.state.history.map((h, i)=>(
										<tr key={i}>
											<td>{h.petition_number}</td>
											<td>{h.petition_timestamp !== null ? moment(h.petition_timestamp).format('DD/MM/YYYY HH:mm') : ""}</td>
											<td>{h.sample_number}</td>
											<td>{h.sample_timestamp !== null ? moment(h.sample_timestamp).format('DD/MM/YYYY HH:mm') : ""}</td>
											<td>{h.sample_grh}</td>
											<td>{h.unit_number}</td>
											<td>{h.component}</td>
											<td>{h.unit_grh}</td>
											<td>{h.compatibility}</td>
											<td>{h.delivered}</td>
										</tr>
									))}
								</tbody>
							</Table>
                            
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.close')} 
						onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
			
	}
}

export default translate('translations') (ModalHistory)